import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DotsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 24 6"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 6)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <g transform="translate(1.5 1.5)">
        <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
        <circle cx="1.5" cy="1.5" r="2.25" />
      </g>
      <g transform="translate(10.5 1.5)">
        <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
        <circle cx="1.5" cy="1.5" r="2.25" />
      </g>
      <g transform="translate(19.5 1.5)">
        <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
        <circle cx="1.5" cy="1.5" r="2.25" />
      </g>
    </SVG>
  );
};
